var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2031 14.8398C15.2031 15.2195 14.921 15.5333 14.5549 15.583L14.4531 15.5898L0.835347 15.5898C0.421134 15.5898 0.0853471 15.2541 0.0853471 14.8398C0.0853472 14.4601 0.367501 14.1464 0.733577 14.0967L0.835347 14.0898L14.4531 14.0898C14.8673 14.0898 15.2031 14.4256 15.2031 14.8398Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46074 18.3857C5.75431 18.6779 5.75541 19.1528 5.46319 19.4464C5.19754 19.7133 4.78094 19.7384 4.48682 19.5213L4.40254 19.4488L0.30587 15.3711C0.0381167 15.1045 0.0137756 14.6863 0.232847 14.3922L0.30587 14.3079L4.40254 10.2302C4.69611 9.93795 5.17098 9.93905 5.46319 10.2326C5.72885 10.4995 5.75209 10.9162 5.53356 11.2093L5.46074 11.2933L1.89875 14.8391L5.46074 18.3857Z",
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.917 4.91211C17.917 5.29181 17.6348 5.6056 17.2688 5.65526L17.167 5.66211L3.54921 5.66211C3.135 5.66211 2.79921 5.32632 2.79921 4.91211C2.79921 4.53241 3.08137 4.21862 3.44744 4.16896L3.54921 4.16211L17.167 4.16211C17.5812 4.16211 17.917 4.4979 17.917 4.91211Z",
    fill: "#878787"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6966 4.38021C17.9643 4.64673 17.9887 5.06498 17.7696 5.35908L17.6966 5.44332L13.5999 9.52109C13.3063 9.81331 12.8315 9.81221 12.5393 9.51864C12.2736 9.25176 12.2504 8.83504 12.4689 8.54194L12.5417 8.45799L16.1048 4.91154L12.5417 1.36554C12.2748 1.09989 12.2497 0.683281 12.4668 0.389167L12.5393 0.304881C12.8049 0.0379998 13.2215 0.0128311 13.5156 0.230007L13.5999 0.30243L17.6966 4.38021Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeIcon);
export default __webpack_public_path__ + "static/media/exchange-icon.86af52d0d71d55c5f898eabb96ec9ad0.svg";
export { ForwardRef as ReactComponent };